import {
  Grid2,
} from '@mui/material';
import {
  FC,
} from 'react';
import { MemberStatsTable } from './MemberStatsTable';
import { TeamSalesCommissionBarChart } from './TeamSalesCommissionBarChart';
import { TeamSalesPercentageDonutChart } from './TeamSalesPercentageDonutChart';
import { TeamHoursWorkedBarChart } from './TeamHoursWorkedBarChart';
import { TSingleTeam } from '../../../../types';

type TSingleTeamAnalytics = TSingleTeam;

const SingleTeamAnalytics: FC<TSingleTeamAnalytics> = ({ team }) => (
  <Grid2 container spacing={2}>
    <Grid2
      size={{
        sm: 12, xs: 12, md: 6, lg: 6,
      }}
    >
      <TeamSalesCommissionBarChart team={team} />
    </Grid2>

    <Grid2
      size={{
        sm: 12, xs: 12, md: 6, lg: 6,
      }}
    >
      <TeamSalesPercentageDonutChart team={team} />
    </Grid2>

    <Grid2
      pt={2}
      size={{
        sm: 12, xs: 12, md: 12, lg: 12,
      }}
    >
      <MemberStatsTable team={team} />
    </Grid2>
    <Grid2
      pt={2}
      size={{
        sm: 12, xs: 12, md: 12, lg: 12,
      }}
    >
      <TeamHoursWorkedBarChart team={team} />
    </Grid2>
  </Grid2>
);

export { SingleTeamAnalytics };
